export default function OptionsRow(props) {
    // console.log(props.rawOptions?.split(','));
    const options = props.rawOptions?.split(',')
    if (options === undefined || options?.length < 1 || options[0] == "") return

    return <div id={props.id} 
                className={props.elementId < props.currentIndex 
                            ? "" 
                            : "disabled-options-block"}
    >
        <h3>{props.optionsTitle}</h3>
        <div className="options-row"> 
            {(options).map((textContent, i) => {
                return <div 
                    className={textContent == props.option ? "text-option text-option-selected" : "text-option"}
                    key={i}
                    onClick={() => {
                        props.setOption(textContent)
                        props.setOptionIndex(props.elementId+2)
                    }}
                    >
                        {textContent}
                </div>
            })}
        </div>
    </div>
}